import { Skeleton } from '@design-system/Skeleton';

interface ImproveMyScoreShimmerProps {
  'data-testid'?: string;
}

const ImproveMyScoreShimmer = ({ 'data-testid': testId }: ImproveMyScoreShimmerProps = {}) => {
  return (
    <div className="mt-8 flex flex-col gap-3 select-none" data-testid={testId}>
      <Skeleton className="w-1/3 h-8" data-testid="healthL2Details-improveScoreTitleSkeleton" />
      <div className="grid sm:grid-cols-1 grid-cols-1 gap-4 w-full h-full" data-testid="healthL2Details-improveScoreCardSkeleton">
        <Skeleton
          key={`grid-skeleton`}
          className={`w-full h-40 rounded-lg block`}
          data-testid="healthL2Details-improveScoreCardSkeletonItem"
        />
      </div>
    </div>
  );
};

export default ImproveMyScoreShimmer;
